import { BaseQueryFn } from '@reduxjs/toolkit/dist/query';
import { AxiosError, AxiosRequestConfig } from 'axios';
import { restClient } from './restClient';

export const axiosBaseQuery =
 (
  { baseUrl }: { baseUrl: string } = { baseUrl: '' },
 ): BaseQueryFn<
  {
   url: string;
   method: AxiosRequestConfig['method'];
   data?: AxiosRequestConfig['data'];
   params?: AxiosRequestConfig['params'];
   responseType?: AxiosRequestConfig['responseType'];
   fallbackFilename?: string;
  },
  unknown,
  unknown
 > =>
 async (restClientOptions) => {
  try {
   const result = await restClient(restClientOptions);

   if (restClientOptions.responseType === 'blob') {
    const disposition: string = result.headers?.['content-disposition'] ?? '';
    const rfc5987Match = disposition.match(/filename\*=UTF-8''([^;\s]+)/i);
    const plainMatch = disposition.match(/filename="?([^";\s]+)"?/i);
    const filename = rfc5987Match?.[1]
     ? decodeURIComponent(rfc5987Match[1])
     : (plainMatch?.[1] ?? restClientOptions.fallbackFilename ?? 'export.xlsx');
    return { data: { blob: result.data as Blob, filename } };
   }

   return result;
  } catch (axiosError) {
   let err = axiosError as AxiosError;

   return {
    error: {
     status: err.response?.status,
     data: err.response?.data || err?.message,
    },
   };
  }
 };
